module.exports = __webpack_public_path__ + "okta-buttons-sprite-001.36eadf174a4679a1a0f4672544e0e762.png";